import { Redirect, Route, Switch } from "react-router";
import { PoliticaPrivacidade } from "./Politicas/PoliticaPrivacidade";

export const Politicas = () => <Switch>
	{/* <Route path="/politicas/termos" component={PoliticasTermosServico} /> */}
	<Route path="/politicas/politica-de-privacidade" component={PoliticaPrivacidade} />
	{/* <Route path="/politicas/praticas-de-privacidade" component={PoliticasPraticasPrivacidade} /> */}
	<Route render={() => <Redirect to="/politicas/termos" />} />
</Switch>
